@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.container {
  border-bottom: 1px solid @filterview-list--container--border-color;
  padding-left: 15px;
  background-color: @filterview-list--container--background-color;
}
